/* eslint-disable */
jQuery( function( $ ) {
	$('.schema-faq-question').on('click', function(event){
		event.preventDefault();
		let accordion = $(this);
		let accordionContent = accordion.next('.schema-faq-answer');
		accordion.toggleClass("open");
		accordionContent.slideToggle(250);
	});
} );

jQuery( function( $ ) {
	$('.c-card-faq__header').on('click', function(event){
		event.preventDefault();
		let accordion = $(this);
		let accordionContent = accordion.next('.c-card-faq__caption');
		accordion.toggleClass("open");
		accordionContent.slideToggle(250);
		console.log( '12312345678');
	});
} );
